import { Menu, Bell, User, ChevronDown } from "lucide-react";
import {
  retrieveData,
  removeData,
} from "../../LocalConnection/LocalConnection.js";
export default function Header({ collapsed, setCollapsed }) {
  const admin_name_with_gender = retrieveData("admin_name_with_gender");
  const designation_name = retrieveData("designation_name");
  const admin_image = retrieveData("admin_image");
  // const restaurant_name = retrieveData("restaurant_name");
  const restaurant_image = retrieveData("restaurant_image");
  return (
    <header className="sticky top-0 z-30 flex h-16 items-center justify-between border-b bg-[var(--white)] backdrop-blur-sm px-2 py-3 md:px-6">
      <div className="flex items-center gap-4">
        <button
          className="max850:hidden md:inline-flex items-center justify-center gap-2 h-9 rounded-md px-3 hover:bg-muted hover:text-accent-foreground"
          onClick={() => setCollapsed(!collapsed)}
        >
          <Menu className="h-5 w-5" />
        </button>
        <div>
          <h2 className="text-[15px] md:text-[22px] font-semibold text-[var(--black)] mb-0">
            Metro <span className="hidden min-[400px]:inline">Operations</span>{" "}
            Center
          </h2>
          <p className="text-[10px] md:text-[13px] text-[var(--grey-text)] mb-0">
            Real-time management & monitoring
          </p>
        </div>
      </div>

      <div className="flex items-center gap-1 md:gap-4">
        {/* <button className="relative inline-flex items-center justify-center h-9 rounded-md px-3 hover:bg-accent hover:text-accent-foreground">
          <Bell className="h-5 w-5 text-[var(--black)]" />
          <div className="absolute -right-1 -top-1 h-5 w-5 rounded-full bg-[var(--red)] text-[var(--white)] text-xs flex items-center justify-center">
            3
          </div>
        </button> */}

        <button
          className="flex items-center gap-2 h-10 px-4 py-2 rounded-md hover:bg-muted hover:text-accent-foreground"
          type="button"
        >
          <div className="flex h-8 w-8 items-center justify-center rounded-full bg-[var(--primary-color)]">
            <User className="h-4 w-4 text-[var(--white)]" />
          </div>
          <div className="hidden text-left md:block">
            <p className="text-sm font-medium text-[var(--black)] mb-0">
              {admin_name_with_gender}{" "}
            </p>
            <p className="text-xs text-[var(--grey-text)] mb-0">
              {designation_name}
            </p>
          </div>
          <ChevronDown className="h-4 w-4" />
        </button>
      </div>
    </header>
  );
}
